(function () {
  "use strict";

  var productsByVideo = {
    d2592c63a0be41a8935c3a989e89cecf: {
      title: "Damon",
      price: "39,99 EUR",
      url: "/products/shorts-de-bain-autres-3823-220815975",
      image: "https://cdn.shopify.com/s/files/1/1029/9886/8308/files/01_6061fc36-ea6d-49c2-8549-1ee4bcdc1593.jpg?v=1778793991&width=120",
    },
    "4ccc510708af43f586e488673a0ef5b7": {
      title: "Tarian",
      price: "39,99 EUR",
      url: "/products/shorts-de-bain-fendre-3815-197726164",
      image: "https://cdn.shopify.com/s/files/1/1029/9886/8308/files/01_31320b22-e75a-440a-851a-aa8ccb562e77.jpg?v=1778794986&width=120",
    },
    d3ba8bce587845159bab545b35ccbc55: {
      title: "Kalina",
      price: "34,99 EUR",
      url: "/products/fendeur-kalina",
      image: "https://cdn.shopify.com/s/files/1/1029/9886/8308/files/01_51c0e34f-6793-4b23-ab7a-628fca56f9f5.jpg?v=1777122025&width=120",
    },
    "6fae668546b342e49bc7da267213a677": {
      title: "Ivoria",
      price: "34,99 EUR",
      url: "/products/fendeur-ivoria",
      image: "https://cdn.shopify.com/s/files/1/1029/9886/8308/files/01_3ddb16bd-8977-4d86-b693-3617d70f0714.jpg?v=1777121957&width=120",
    },
    a67c9379f5ea445791292c6ec617da6b: {
      title: "Elsae",
      price: "34,99 EUR",
      url: "/products/fendeur-elsae",
      image: "https://cdn.shopify.com/s/files/1/1029/9886/8308/files/01_dfe28e93-cb81-42d4-b885-b8a2db1dedd4.jpg?v=1778823888&width=120",
    },
    ba1e849840e642b0be6e235d288a78b3: {
      title: "Elsae",
      price: "34,99 EUR",
      url: "/products/fendeur-elsae",
      image: "https://cdn.shopify.com/s/files/1/1029/9886/8308/files/01_dfe28e93-cb81-42d4-b885-b8a2db1dedd4.jpg?v=1778823888&width=120",
    },
    "3e00c31dd69b43a6867624465c6c8558": {
      title: "Giverny",
      price: "34,99 EUR",
      url: "/products/gouache-giverny",
      image: "https://cdn.shopify.com/s/files/1/1029/9886/8308/files/01_25adf307-2e9d-4814-8947-f014fff2663f.jpg?v=1777066350&width=120",
    },
    "8a64eca2bc20480aa9a686a4b2ed91d4": {
      title: "Maïlie",
      price: "34,99 EUR",
      url: "/products/fendeur-mailie",
      image: "https://cdn.shopify.com/s/files/1/1029/9886/8308/files/01_f6c7d6f1-4ff4-482b-b401-d5f16390c4ff.jpg?v=1777122213&width=120",
    },
    "38f54018935f4114a1b4f1f70c0b944a": {
      title: "Nerida",
      price: "34,99 EUR",
      url: "/products/brume-nerida",
      image: "https://cdn.shopify.com/s/files/1/1029/9886/8308/files/nerida.jpg?v=1778954751&width=120",
    },
  };

  function injectLayout() {
    if (document.getElementById("studio-sternify-product-card-layout")) return;

    var style = document.createElement("style");
    style.id = "studio-sternify-product-card-layout";
    style.textContent =
      ".st_ugc-section-slider-bottom:has(.st_ugc-product-card){display:grid!important;grid-template-columns:minmax(0,3fr) minmax(70px,1fr)!important;align-items:end!important;gap:10px!important;padding:0 10px 10px!important;box-sizing:border-box!important}" +
      ".st_ugc-section-slider-bottom:has(.st_ugc-product-card) .st_ugc-product-card{grid-column:1!important;grid-row:1!important;width:100%!important;max-width:none!important;margin:0!important;box-sizing:border-box!important}" +
      ".st_ugc-section-slider-bottom:has(.st_ugc-product-card) .st_ugc-section-slider-description{grid-column:2!important;grid-row:1!important;width:auto!important;min-width:0!important;padding:0!important;margin:0!important;justify-content:flex-end!important;align-self:end!important}" +
      ".st_ugc-section-slider-bottom:has(.st_ugc-product-card) .st_ugc-section-slider-description-text{display:none!important}" +
      ".st_ugc-product-card__title{overflow:hidden!important;display:-webkit-box!important;-webkit-line-clamp:2!important;-webkit-box-orient:vertical!important}" +
      "@media(max-width:480px){.st_ugc-section-slider-bottom:has(.st_ugc-product-card){grid-template-columns:minmax(0,3fr) minmax(64px,1fr)!important;gap:8px!important;padding:0 10px 10px!important}}";

    document.head.appendChild(style);
  }

  function sourceFor(slide) {
    var video = slide.querySelector("video");
    return (video && (video.currentSrc || video.src || (video.querySelector("source") || {}).src)) || "";
  }

  function productFor(slide) {
    var source = sourceFor(slide);
    for (var hash in productsByVideo) {
      if (Object.prototype.hasOwnProperty.call(productsByVideo, hash) && source.indexOf(hash) !== -1) {
        return productsByVideo[hash];
      }
    }
    return null;
  }

  function buildCard(product) {
    var card = document.createElement("a");
    card.className = "st_ugc-product-card";
    card.href = product.url;
    card.setAttribute("aria-label", "Voir " + product.title);

    var image = document.createElement("img");
    image.className = "st_ugc-product-card__image";
    image.src = product.image;
    image.alt = product.title;
    image.loading = "lazy";
    card.appendChild(image);

    var info = document.createElement("div");
    info.className = "st_ugc-product-card__info";

    var title = document.createElement("div");
    title.className = "st_ugc-product-card__title";
    title.textContent = product.title;
    info.appendChild(title);

    var price = document.createElement("div");
    price.className = "st_ugc-product-card__price";
    price.textContent = product.price;
    info.appendChild(price);

    card.appendChild(info);
    return card;
  }

  function apply() {
    injectLayout();

    var slides = document.querySelectorAll(".st_ugc-section-slider");
    for (var i = 0; i < slides.length; i += 1) {
      var slide = slides[i];
      var product = productFor(slide);
      if (!product) continue;

      var text = slide.querySelector(".st_ugc-section-slider-description-text");
      if (text) text.style.display = "none";

      var bottom = slide.querySelector(".st_ugc-section-slider-bottom");
      if (!bottom || bottom.querySelector(".st_ugc-product-card")) continue;

      bottom.appendChild(buildCard(product));
    }
  }

  function start() {
    apply();
    var attempts = 0;
    var interval = window.setInterval(function () {
      attempts += 1;
      apply();
      if (attempts >= 12) window.clearInterval(interval);
    }, 500);
    window.addEventListener("pageshow", apply);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
